import { RECRUITERBUILDREQUIREMENT } from "../../../ENVIRONMENT";

// api for submit recruiter snapshot
async function recsnapshot(token, id) {
  return await fetch(RECRUITERBUILDREQUIREMENT + `/${id}/finish`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${
        token ? token : sessionStorage.getItem("token")
      }`,
    },
  });
}

export { recsnapshot };
